<template>
  <div class="main-header">
    <div @click.stop="toggleMenu" class="main-header__icon">
      <img src="@/assets/images/svg/drop-down.svg" alt="drop down" />
    </div>
    <ul v-if="isOpen" class="main-header__list">
      <li
          class="main-header__list__item"
          @click.stop="$router.push('/profile')"
      >
        My profile
      </li>
      <li
          class="main-header__list__item"
          @click.stop="logoutHandler"
      >
        Logout
      </li>
    </ul>
  </div>
</template>

<script>
import { logout } from "@/services/auth";

export default {
  name: "MainHeader",
  data() {
    return {
      isOpen: false
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.isOpen = false
    })
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    logoutHandler() {
      logout()
      this.$router.push('/sign-in')
    }
  }
};
</script>

<style lang="scss" scoped>
.main-header {
  display: flex;
  justify-content: right;

  &__icon {
    cursor: pointer;
    height: 3.125rem;
    z-index: 3;

    img {
      height: 100%;
      width: 100%;
    }
  }

  &__list {
    list-style: none;
    position: absolute;
    right: 0;
    font-weight: 600;
    cursor: pointer;
    margin: 0;
    padding: 2rem 0 0 0;
    width: 15rem;
    background: #F4F7F8;
    z-index: 2;

    &__item {
      padding: 0.5rem 1.25rem;
      text-align: left;

      a {
        text-decoration: none;
        color: black;
      }

      &:hover {
        background: blueviolet;
        color: white;

        a {
          color: white;
        }
      }
    }
  }

}
</style>